import React from 'react';
import { FormattedMessage } from 'react-intl'

const Field = ({ name, children, handleChange, handleBlur, touched, errors, values }) => (
  <div className="form__field">
    <label className="form__label" htmlFor={name}>
      <FormattedMessage id={`form.${name}`} />
    </label>
    <div className="form__value">
      {
        React.cloneElement(
          children,
          {
            name,
            onChange: handleChange,
            onBlur: handleBlur,
            value: values[name]
          }
        )
      }
      {
        touched[name] && errors[name] &&
          <div className="form__error">{errors[name]}</div>
      }
    </div>
  </div>
);

export default Field;



// WEBPACK FOOTER //
// ./src/components/Field.js